// Search Popup Scripts for _search_popup.html.erb

// Turbolinks Classic compatibility
var searchReady;
searchReady = function () {
  const popup = document.getElementById('searchPopup');
  const input = document.getElementById('searchPopupInput');
  const results = document.getElementById('searchResults');
  const emptyState = document.getElementById('searchEmptyState');
  const recentLinksState = document.getElementById('searchRecentLinksState');
  const loadingState = document.getElementById('searchLoadingState');
  const resultsContainer = document.getElementById('searchResultsContainer');
  
  // Skip if elements don't exist (partial not rendered)
  if (!popup || !input || !results) return;
  
  let selectedIndex = -1;
  let searchTimeout;
  let currentResults = [];

  // Remove existing event listeners to prevent duplicates
  const existingKeyHandler = window.searchPopupKeyHandler;
  if (existingKeyHandler) {
    document.removeEventListener('keydown', existingKeyHandler);
  }

  // Open popup with Cmd+K or Ctrl+K
  function keydownHandler(e) {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      openSearchPopup();
    }
    
    if (e.key === 'Escape' && popup.classList.contains('active')) {
      closeSearchPopup();
    }
  }
  
  document.addEventListener('keydown', keydownHandler);
  window.searchPopupKeyHandler = keydownHandler;

  // Handle click on search trigger button
  const searchTrigger = document.getElementById('searchCommandTrigger');
  if (searchTrigger) {
    searchTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      openSearchPopup();
    });
  }

  // Close popup when clicking overlay
  popup.addEventListener('click', function(e) {
    if (e.target === popup) {
      closeSearchPopup();
    }
  });

  // Handle search input
  input.addEventListener('input', function() {
    const query = input.value.trim();
    
    clearTimeout(searchTimeout);
    
    if (query.length === 0) {
      showEmptyState();
      return;
    }
    
    if (query.length < 2) {
      return;
    }
    
    showLoadingState();
    
    // Debounce search
    searchTimeout = setTimeout(() => {
      performSearch(query);
    }, 300);
  });

  // Handle keyboard navigation
  input.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      navigateResults(1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      navigateResults(-1);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      selectCurrentResult();
    }
  });

  function openSearchPopup() {
    popup.classList.add('active');
    input.focus();
    document.body.style.overflow = 'hidden';
    showEmptyState(); // Show recent links or empty state
  }

  function closeSearchPopup() {
    popup.classList.remove('active');
    input.value = '';
    selectedIndex = -1;
    currentResults = [];
    showEmptyState();
    document.body.style.overflow = '';
  }

  function showEmptyState() {
    // Check if we have recent links to show
    if (displayRecentLinks()) {
      emptyState.style.display = 'none';
      recentLinksState.style.display = 'block';
    } else {
      emptyState.style.display = 'block';
      recentLinksState.style.display = 'none';
    }
    loadingState.style.display = 'none';
    resultsContainer.style.display = 'none';
  }

  function displayRecentLinks() {
    const recentLinks = JSON.parse(localStorage.getItem('recentLinks')) || [];
    const recentLinksResults = document.getElementById('recentLinksResults');
    
    // Always show the Ask AI command, even if no recent links
    // Clear existing results and reset currentResults
    recentLinksResults.innerHTML = '';
    currentResults = [];

    // Show up to 3 most recent links
    recentLinks.slice(0, 3).forEach((link, index) => {
      const resultItem = createRecentLinkItem(link, index);
      recentLinksResults.appendChild(resultItem);
      // Add to currentResults for keyboard navigation
      currentResults.push(link);
    });

    // Always add the "Ask AI" command
    const askAICommand = {
      title: "Ask Heights AI",
      description: "Ask AI a question about using Heights or growing your business",
      action_type: "direct",
      category: "ai-actions"
    };
    
    const askAIItem = createAskAICommandItem(askAICommand, currentResults.length);
    recentLinksResults.appendChild(askAIItem);
    currentResults.push(askAICommand);

    return true; // Always return true since we always show Ask AI command
  }

  function createRecentLinkItem(link, index) {
    const div = document.createElement('div');
    div.className = 'search-result-item';
    div.dataset.index = index;
    
    div.innerHTML = `
      <div class="search-result-icon recent">
        <i class="fa-sharp fa-regular fa-clock-rotate-left"></i>
      </div>
      <div class="search-result-content">
        <div class="search-result-title">${escapeHtml(link.name)}</div>
        <div class="search-result-description">Recently visited</div>
        <div class="search-result-meta">Recent</div>
      </div>
    `;
    
    div.addEventListener('click', () => {
      window.location.href = link.url;
    });
    
    return div;
  }

  function createAskAICommandItem(command, index) {
    const div = document.createElement('div');
    div.className = 'search-result-item ai-action';
    div.dataset.index = index;
    
    div.innerHTML = `
      <div class="search-result-icon ai-action">
        <svg width="16" height="16" viewBox="0 0 1527 1043" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
									<defs>
										<linearGradient id="aniGradient" x1="30%" y1="70%">
											<stop offset="10%" stop-color="#00cb58">
												<animate attributeName="stop-color" values="#00cb58; #ff751f; #00cb58;" dur="4s" fill="freeze" repeatCount="indefinite" />
											</stop>
											<stop offset="50%" stop-color="#00a6ff">
												<animate attributeName="stop-color" values="#00a6ff; #00cb58; #00a6ff;" dur="4s" fill="freeze" repeatCount="indefinite" />
											</stop>
											<stop offset="100%" stop-color="#ff751f">
												<animate attributeName="stop-color" values="#ff751f; #00cb58; #ff751f;" dur="4s" fill="freeze" repeatCount="indefinite" />
											</stop>
										</linearGradient>
										<linearGradient id="aniGradient2" x1="30%" y1="70%">
											<stop offset="10%" stop-color="#00cb58">
												<animate attributeName="stop-color" values="#00cb58; #ff751f; #00cb58;" dur="4s" fill="freeze" repeatCount="indefinite" />
											</stop>
											<stop offset="50%" stop-color="#ff751f">
												<animate attributeName="stop-color" values="#ff751f; #00cb58; #ff751f;" dur="4s" fill="freeze" repeatCount="indefinite" />
											</stop>
											<stop offset="100%" stop-color="#00a6ff">
												<animate attributeName="stop-color" values="#00a6ff; #ff751f; #00a6ff;" dur="4s" fill="freeze" repeatCount="indefinite" />
											</stop>
										</linearGradient>
										<linearGradient id="grad2" x1="30%" y1="70%">
											<stop offset="0%" stop-color="#20b15d">
												<animate attributeName="stop-color" values="#20b15d; #20b15d; #20b15d;" dur="4s" fill="freeze" repeatCount="indefinite" />
											</stop>
											<stop offset="100%" stop-color="#2bec7c">
												<animate attributeName="stop-color" values="#2bec7c; #20b15d; #2bec7c;" dur="4s" fill="freeze" repeatCount="indefinite" />
											</stop>
										</linearGradient>
									</defs>
									<g id="Heights-AI" serif:id="Heights AI">
										<path d="M182.297,845.223L156.094,705.701L13.861,678.989C5.823,677.48 0,670.461 0,662.283C0,654.105 5.823,647.086 13.861,645.576L156.094,618.864L182.807,476.631C184.316,468.593 191.335,462.77 199.513,462.77C207.691,462.77 214.71,468.593 216.219,476.631L242.932,618.864L319.73,633.287L276.91,699.32L242.932,705.701L230.766,770.479L182.297,845.223Z" fill="url(#aniGradient)" />
										<path d="M391.467,522.661C389.676,520.093 388.396,517.122 387.788,513.882L352.148,324.116L162.382,288.477C151.659,286.463 143.89,277.098 143.89,266.187C143.89,255.276 151.659,245.912 162.382,243.898L352.148,208.259L387.788,18.493C389.802,7.769 399.166,0 410.077,0C420.988,0 430.352,7.769 432.366,18.493L468.006,208.259L581.52,229.578L527.456,312.951L468.006,324.116L446.72,437.454L391.467,522.661Z" fill="url(#aniGradient)"/>
										<path d="M1273.38,883.689L1336.41,980.899C1344.4,993.218 1345.01,1008.92 1338,1021.82C1330.99,1034.72 1317.49,1042.76 1302.8,1042.76L227.25,1042.76C212.567,1042.76 199.06,1034.72 192.05,1021.82C185.04,1008.92 185.649,993.218 193.638,980.899L731.414,151.588C738.8,140.199 751.451,133.324 765.026,133.324C778.601,133.324 791.252,140.199 798.638,151.588L953.291,390.08L900.496,399.996C849.875,409.503 813.199,453.708 813.199,505.214C813.199,556.719 849.875,600.925 900.496,610.432L1073.68,642.957L1106.2,816.14C1115.71,866.76 1159.92,903.437 1211.42,903.437C1234.32,903.437 1255.77,896.188 1273.38,883.689Z" fill="url(#grad2)"/>
										<path d="M1188.11,209.669C1190.21,198.452 1200.01,190.324 1211.42,190.324C1222.84,190.324 1232.63,198.452 1234.74,209.669C1253.86,311.467 1277.78,438.854 1277.78,438.854C1277.78,438.854 1405.17,462.779 1506.97,481.897C1518.18,484.004 1526.31,493.8 1526.31,505.214C1526.31,516.627 1518.18,526.423 1506.97,528.53C1405.17,547.649 1277.78,571.573 1277.78,571.573C1277.78,571.573 1253.86,698.96 1234.74,800.758C1232.63,811.976 1222.84,820.103 1211.42,820.103C1200.01,820.103 1190.21,811.976 1188.11,800.758C1168.99,698.96 1145.06,571.573 1145.06,571.573C1145.06,571.573 1017.68,547.649 915.878,528.53C904.66,526.423 896.532,516.627 896.532,505.214C896.532,493.8 904.66,484.004 915.878,481.897C1017.68,462.779 1145.06,438.854 1145.06,438.854C1145.06,438.854 1168.99,311.467 1188.11,209.669Z" fill="url(#aniGradient2)"/>
									</g>
								</svg>
      </div>
      <div class="search-result-content">
        <div class="search-result-title">${escapeHtml(command.title)}</div>
        <div class="search-result-description">${escapeHtml(command.description)}</div>
        <div class="search-result-meta">Command</div>
      </div>
    `;
    
    div.addEventListener('click', () => {
      try {
        // Find and click the AI link
        const aiLinks = document.querySelectorAll('.ai-link');
        if (aiLinks.length > 0) {
          aiLinks[0].click();
          closeSearchPopup();
        } else {
          // Fallback: try jQuery if available
          if (window.$ && $('.ai-link').length > 0) {
            $('.ai-link').trigger('click');
            closeSearchPopup();
          } else {
            console.error('No .ai-link elements found on page');
            alert('AI chat not available on this page. Try navigating to your admin dashboard first.');
          }
        }
      } catch (error) {
        console.error('Error executing Ask AI command:', error);
        alert(`Ask AI command error: ${error.message}`);
      }
    });
    
    return div;
  }

  function showLoadingState() {
    emptyState.style.display = 'none';
    recentLinksState.style.display = 'none';
    loadingState.style.display = 'block';
    resultsContainer.style.display = 'none';
  }

  function showResults() {
    emptyState.style.display = 'none';
    recentLinksState.style.display = 'none';
    loadingState.style.display = 'none';
    resultsContainer.style.display = 'block';
  }

  function performSearch(query) {
    // This would typically make an AJAX request to your Rails backend
    // For now, we'll simulate with a timeout
    
    fetch(`/search?q=${encodeURIComponent(query)}`, {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      displayResults(data);
    })
    .catch(error => {
      console.error('Search error:', error);
      showEmptyState();
    });
  }

  function displayResults(data) {
    currentResults = [];
    
    // Clear recent links HTML to prevent keyboard navigation issues
    const recentLinksResults = document.getElementById('recentLinksResults');
    if (recentLinksResults) {
      recentLinksResults.innerHTML = '';
    }
    
    // Clear all categories
    ['courses', 'lessons', 'channels', 'products', 'projects', 'bundles', 'commands'].forEach(category => {
      const categoryDiv = document.getElementById(category + 'Category');
      const resultsDiv = document.getElementById(category + 'Results');
      categoryDiv.style.display = 'none';
      resultsDiv.innerHTML = '';
    });

    // Populate results for each category
    Object.keys(data).forEach(category => {
      if (data[category] && data[category].length > 0) {
        displayCategoryResults(category, data[category]);
      }
    });

    showResults();
    selectedIndex = -1;
  }

  function displayCategoryResults(category, items) {
    const categoryDiv = document.getElementById(category + 'Category');
    const resultsDiv = document.getElementById(category + 'Results');
    
    categoryDiv.style.display = 'block';
    
    items.forEach((item, index) => {
      const resultItem = createResultItem(item, category, currentResults.length);
      resultsDiv.appendChild(resultItem);
      currentResults.push(item);
    });
  }

  function createResultItem(item, category, index) {
    const div = document.createElement('div');
    div.className = 'search-result-item';
    div.dataset.index = index;
    
    // Special styling for AI action commands
    if (item.category === 'ai-actions') {
      div.classList.add('ai-action');
    }
    
    // Handle custom icons for commands
    let iconHtml;
    if (category === 'commands') {
      if (item.svg_icon) {
        // Use SVG icon directly
        iconHtml = `<div class="search-result-icon ${item.category === 'ai-actions' ? 'ai-action' : category}">
          ${item.svg_icon}
        </div>`;
      } else if (item.icon) {
        // Use Font Awesome icon
        iconHtml = `<div class="search-result-icon ${item.category === 'ai-actions' ? 'ai-action' : category}">
          <i class="fas ${item.icon}"></i>
        </div>`;
      } else {
        // Fallback
        const iconClass = getIconClass(category);
        iconHtml = `<div class="search-result-icon ${category}"><i class="${iconClass}"></i></div>`;
      }
    } else {
      const iconClass = getIconClass(category);
      iconHtml = `<div class="search-result-icon ${category}"><i class="${iconClass}"></i></div>`;
    }
    
    div.innerHTML = `
      ${iconHtml}
      <div class="search-result-content">
        <div class="search-result-title">${escapeHtml(item.title || item.name)}</div>
        <div class="search-result-description">${escapeHtml(item.description || '')}</div>
        <div class="search-result-meta">${getCategoryDisplayName(category)}</div>
      </div>
    `;
    
    // Handle click based on action type
    div.addEventListener('click', () => {
      if (item.action_type === 'javascript') {
        // Execute JavaScript function
        try {
          eval(item.javascript);
          closeSearchPopup(); // Close popup after executing command
        } catch (error) {
          console.error('Error executing command:', error);
          alert('This command is not yet implemented.');
        }
      } else {
        // Regular URL navigation
        window.location.href = item.url;
      }
    });
    
    return div;
  }

  function getIconClass(category) {
    const icons = {
      commands: 'fa-terminal',
      courses: 'fa-folder',
      lessons: 'fa-play',
      channels: 'fa-comments',
      products: 'fa-cube',
      projects: 'fa-briefcase',
      bundles: 'fa-box-dollar'
    };
    return `fas ${icons[category] || 'fa-file'}`;
  }

  function getCategoryDisplayName(category) {
    const names = {
      commands: 'Command',
      courses: 'Course',
      lessons: 'Lesson',
      channels: 'Community Channel',
      products: 'Product',
      projects: 'Project',
      bundles: 'Offer'
    };
    return names[category] || category;
  }

  function navigateResults(direction) {
    if (currentResults.length === 0) return;
    
    selectedIndex += direction;
    
    if (selectedIndex < 0) {
      selectedIndex = currentResults.length - 1;
    } else if (selectedIndex >= currentResults.length) {
      selectedIndex = 0;
    }
    
    updateSelectedResult();
  }

  function updateSelectedResult() {
    // Remove previous selection
    const previousSelected = results.querySelector('.search-result-item.selected');
    if (previousSelected) {
      previousSelected.classList.remove('selected');
    }
    
    // Add new selection
    if (selectedIndex >= 0) {
      const newSelected = results.querySelector(`[data-index="${selectedIndex}"]`);
      if (newSelected) {
        newSelected.classList.add('selected');
        newSelected.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  function selectCurrentResult() {
    if (selectedIndex >= 0 && currentResults[selectedIndex]) {
      const item = currentResults[selectedIndex];
      
      if (item.action_type === 'javascript') {
        // Execute JavaScript function
        try {
          eval(item.javascript);
          closeSearchPopup(); // Close popup after executing command
        } catch (error) {
          console.error('Error executing command:', error);
          alert('This command is not yet implemented.');
        }
      } else if (item.action_type === 'direct') {
        // Handle direct AI command
        try {
          // Find and click the AI link
          const aiLinks = document.querySelectorAll('.ai-link');
          if (aiLinks.length > 0) {
            aiLinks[0].click();
            closeSearchPopup();
          } else {
            // Fallback: try jQuery if available
            if (window.$ && $('.ai-link').length > 0) {
              $('.ai-link').trigger('click');
              closeSearchPopup();
            } else {
              console.error('No .ai-link elements found on page');
              alert('AI chat not available on this page. Try navigating to your admin dashboard first.');
            }
          }
        } catch (error) {
          console.error('Error executing Ask AI command:', error);
          alert(`Ask AI command error: ${error.message}`);
        }
      } else {
        // Regular URL navigation (works for both search results and recent links)
        window.location.href = item.url;
      }
    }
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Make functions available globally for Rails integration
  window.searchPopup = {
    open: openSearchPopup,
    close: closeSearchPopup
  };
};

$(document).ready(searchReady);
/**
 * if using turbolinks
 */
$(document).on('page:load', searchReady);

// Placeholder functions for AI command actions
// Replace these with your actual implementations
function openProductGeneratorModal() {
  $('#aiOnboardingModal').modal('show');
}

function openWebPageGeneratorModal() {
  //toggle ai web page generator modal
  // ie it is a bootstrap modal like this: 
  // <a href="#" class="btn ai-cta ai-cta-edit-page ai-cta-large" data-toggle="modal" data-target="#aiWebpageModal" data-bundle-id="<%= @bundle.id %>"></a>
  // so we need to toggle the modal and call the modal show event?
  $('#aiWebpageModal').modal('show');

}